/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Private_LabelInputs */



/**
* | output |
* | --- |
* | "Keep this decklist private" |
*
* @param {Deck_Private_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_private_label = /** @type {((inputs?: Deck_Private_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Private_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Garder ce deck privé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mantener este mazo privado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Manter este deck privado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mantieni privato questo mazzo")
	return /** @type {LocalizedString} */ ("Keep this decklist private")
});